import { addDoc, collection, doc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { message } from "antd";
import { toast } from "react-hot-toast";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../firebase";

export const createNewRecurringWorkOrder = async (
  values,
  filterOptions,
  accounts,
  companyName,
  filteredNotes,
  files
) => {
  const companiesRef = collection(db, "companies");
  const companyDocRef = doc(companiesRef, companyName);
  const newRecurringWorkOrderRef = collection(
    companyDocRef,
    "recurringWorkOrders"
  );

  const uniqueIds = {}; // Helper object to keep track of seen ids
  const imagesUrl = []; // Helper object to keep track of seen ids
  const uniqueItems = files.filter((item) => {
    // If the id is not in the uniqueIds object, add it and return true
    if (!uniqueIds[item.uid]) {
      uniqueIds[item.uid] = true;
      return true;
    }
    // If the id is already in the uniqueIds object, return false to filter it out
    return false;
  });

  for (const file of uniqueItems) {
    const storageRef = ref(storage, `/files/recurringWorkOrders/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    try {
      await uploadTask;

      // File uploaded successfully
      const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
      const fileData = {
        downloadURL: downloadURL,
        id: file.uid,
        name: file.name,
        type: file.type,
        isDefault: false,
      };
      imagesUrl.push(fileData);
      console.log("Download URL for", file.name, ":", downloadURL);
    } catch (error) {
      console.error("Upload error for", file.name, ":", error);
    }
  }

  console.log("files", files);
  console.log("imagesUrlimagesUrlimagesUrl", imagesUrl);

  try {
    await addDoc(newRecurringWorkOrderRef, {
      recurranceInformation: {
        startDate: values.startDate
          ? values.startDate.format("YYYY-MM-DD")
          : "" || "",
        endDate: values.endDate
          ? values.endDate.format("YYYY-MM-DD")
          : "" || "",
        repeats: values.repeat || "",
        postDay: values.postDay || "",
        selectedMonths: filterOptions || null,
      },

      details: {
        propertyInfo: {
          propertyId: values.properties || "",
          unit: values.unit || null,
          creationStyle: values.creationStyle || "",
        },
        workOrderInfo: {
          description: values.description || "",
          vendorInstructions: values.vendorInstructions || "",
        },
        vendorInfo: {
          vendorId: values.vendor || "",
          adjustmentPercent: values.adjustmentPercent || "",
          adjustmentType: values.adjustmentType || "",
          assignTo: values.assignTo || null,
        },
        billingInfo: accounts.length > 0 ? accounts : [],
      },
      notes: filteredNotes,
      attachments: imagesUrl ? imagesUrl : [],
    });
    toast.success("Created Successfuly");
  } catch (error) {
    message.error(
      "Error in creating new Recurring Work Order..........:",
      error
    );
  }
};
